import { Helper } from '../../Helper';
export class BufferLengthHelper extends Helper {
    emit(sb, node, options) {
        if (!options.pushValue) {
            sb.emitOp(node, 'DROP');
            return;
        }
        sb.emitHelper(node, options, sb.helpers.unwrapBuffer);
        sb.emitOp(node, 'SIZE');
    }
}

//# sourceMappingURL=BufferLengthHelper.js.map
